// Misura di distanze: click successivi sulla mappa, etichetta per segmento.

import { useCallback, useEffect, useRef, useState } from "react";
import L from "leaflet";

const COLOR = "#84e34c";

export function formatDistance(m) {
  return m < 1000 ? `${Math.round(m)} m` : `${(m / 1000).toFixed(3)} km`;
}

export default function useMeasure(map) {
  const [active, setActive] = useState(false);
  const [total, setTotal] = useState(0);
  const [count, setCount] = useState(0);
  const layerRef = useRef(null);
  const ptsRef = useRef([]);

  const reset = useCallback(() => {
    try {
      if (layerRef.current && map) map.removeLayer(layerRef.current);
    } catch { /* mappa già rimossa */ }
    layerRef.current = null;
    ptsRef.current = [];
    setTotal(0);
    setCount(0);
  }, [map]);

  const stop = useCallback(() => {
    setActive(false);
    reset();
  }, [reset]);

  useEffect(() => {
    if (!map || !active) return undefined;
    map.getContainer().style.cursor = "crosshair";
    map.doubleClickZoom.disable();

    const onClick = (e) => {
      map.closePopup();
      const pts = ptsRef.current;
      pts.push(e.latlng);
      if (!layerRef.current) layerRef.current = L.layerGroup().addTo(map);
      const layer = layerRef.current;
      layer.clearLayers();
      pts.forEach((pt) =>
        L.circleMarker(pt, { radius: 4, color: COLOR, fillColor: "#02030a", fillOpacity: 1, weight: 2, interactive: false }).addTo(layer)
      );
      let sum = 0;
      if (pts.length > 1) {
        L.polyline(pts, { color: COLOR, weight: 2.5, dashArray: "6 4", interactive: false }).addTo(layer);
        for (let i = 1; i < pts.length; i++) {
          const d = map.distance(pts[i - 1], pts[i]);
          sum += d;
          const mid = L.latLng((pts[i - 1].lat + pts[i].lat) / 2, (pts[i - 1].lng + pts[i].lng) / 2);
          L.marker(mid, {
            icon: L.divIcon({ className: "measure-label", html: formatDistance(d), iconAnchor: [22, 8] }),
            interactive: false,
          }).addTo(layer);
        }
      }
      setTotal(sum);
      setCount(pts.length);
    };
    map.on("click", onClick);
    return () => {
      map.off("click", onClick);
      try {
        map.getContainer().style.cursor = "";
        map.doubleClickZoom.enable();
      } catch { /* mappa già rimossa */ }
    };
  }, [map, active]);

  useEffect(() => () => reset(), [reset]);

  return { active, total, count, start: () => setActive(true), stop };
}
